export const mineralsInitialState = {
    minerals: null,
    isLoading: true,
    pagination: null
}